import { memo } from 'react';
import ConfirmCodeInput from '../../../ConfirmCodeInput';

const ConfirmCode = ({ input, data }) => {
  // @ts-expect-error ts-migrate(2741) FIXME: Property 'values' is missing in type '{ onChange: ... Remove this comment to see the full error message
  return <ConfirmCodeInput onChange={input.onChange} />;
};

export default memo(ConfirmCode);
